interface TriggerData {
  id: string;
  triggerType: string;
  cronExpression: string | null;
  scheduleDesc: string | null;
  eventSource: string | null;
  eventType: string | null;
  status: string;
  lastFiredAt: string | null;
  fireCount: number;
}

interface Props {
  trigger: TriggerData;
  onPause?: () => void;
  onResume?: () => void;
  onDelete?: () => void;
}

function formatRelativeTime(date: string): string {
  const diff = Date.now() - new Date(date).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export function TriggerCard({ trigger }: Props) {
  const isPeriodic = trigger.triggerType === 'periodic';

  return (
    <div className="trigger-card">
      <div className="trigger-icon">
        {isPeriodic ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        )}
      </div>
      <div className="trigger-body">
        <div className="trigger-name">
          {trigger.scheduleDesc ?? trigger.cronExpression ?? `${trigger.eventType} from ${trigger.eventSource}`}
        </div>
        <div className="trigger-meta">
          {isPeriodic ? 'Periodic' : 'Event-based'}
          {trigger.lastFiredAt && ` · Last fired ${formatRelativeTime(trigger.lastFiredAt)}`}
          {trigger.fireCount > 0 && ` · ${trigger.fireCount} fires`}
        </div>
      </div>
      <span className={`trigger-status ${trigger.status === 'paused' ? 'paused' : ''}`}>
        {trigger.status === 'active' ? 'Active' : 'Paused'}
      </span>
    </div>
  );
}
